import stateModifier from "./utils/stateModifier";

export const initialState = {
  displayBackgroundImage: true,
  toast: {
    toastContent: " ",
    toastVariant: "",
    showToast: false,
    autoHide: true,
  },
};

const actionMap = new Map();

actionMap.set("SHOW_BACKGROUND", (state, action) => ({
  ...state,
  displayBackgroundImage: action.data,
}));

actionMap.set("SHOW_GLOBAL_TOAST", (state, action) => ({
  ...state,
  toast: {
    ...state.toast,
    toastContent: action.data.content,
    toastVariant: action.data.variant,
    showToast: action.data.showToast,
  },
}));

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  return stateModifier(state, action, actionMap);
};
